// extracted by mini-css-extract-plugin
export default {"AccordionButton":"style_AccordionButton__RxSCj","AccordionPanel":"style_AccordionPanel__omYE-"};